<template>
  <div>
    <div class="flex justify-end">
      <button
          v-if="show"
          @click="exportData"
          type="button"
          class="block rounded-md px-3 py-2 text-center text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-gray-600 text-white hover:bg-gray-500 focus-visible:outline-gray-600 m-1">
        Export
      </button>
      <RouterLink v-if="show" :to="{ name: 'QuestionSetAuditorIndex', params: { question_set_id: questionSetId }}" class="block rounded-md px-3 py-2 text-center text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-gray-600 text-white hover:bg-gray-500 focus-visible:outline-gray-600 m-1">
        Set Auditor Index
      </RouterLink>
    </div>
    <question-nested-parent-draggable v-if="show" :items="data" :question-set-id="questionSetId" @save-change-parent="save"/>
  </div>
</template>

<script>
import _ from 'lodash'
import QuestionNestedParentDraggable from "../Reorder/QuestionNestedDraggableParentComponent.vue";
import {CheckCircleIcon, XCircleIcon} from "@heroicons/vue/20/solid";

export default {
  name: "QuestionSetShowComponent",
  data() {
    return {
      data: [],
      show: false
    }
  },
  components: {
    QuestionNestedParentDraggable,
    CheckCircleIcon,
    XCircleIcon,
  },
  computed: {
    questionSetId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
  },
  methods: {
    getQuestions() {
      axios.get(`/member-firm/question-set/show/${this.questionSetId}`).then((res) => {
        let data = {}
        res.data.forEach(element => {
          if(!data['parent_id_' + element.parent.id]){
            data['parent_id_' + element.parent.id] = {
              'parent': element.parent,
              'items': [element]
            };
          }else{
            data['parent_id_' + element.parent.id].items.push(element);
          }
        });
        this.data = Object.values(data);
        this.show = true;
      }).catch((error) => {
        console.log('error', error);
        this.$notify({ title: "Unsuccessfully", text: error.message });
      })
    },
    save() {
      let sectionsSort = [];
      let questionsSort = [];

      this.data.forEach((entry) => {
        entry.items.forEach((section) => {
          sectionsSort.push(section.id);
          section.questions.forEach((question) => {
            questionsSort.push(question.id);
            if(question.children.length)
              questionsSort.push(..._.map(question.children, 'id'));
          });
        });
      });

      if (questionsSort.length)
        axios.post(`/member-firm/question-set/reorder/${this.questionSetId}`, {
          sections: sectionsSort,
          questions: questionsSort
        }).then(res => {
          console.log('res', res)
          this.$notify({ type: "success", title: "Successfully", text: "Changes succeed saved" });
          this.getQuestions();
        }).catch(error => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        });
    },
    exportData() {
      axios.get(
          `/member-firm/question-set/export-question-set-csv/${this.questionSetId}`,
          {
            responseType: 'blob'
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export_questions_set.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$notify({ type: "success", title: "Successfully", text: 'Download in process' });
      }).catch((error) => {
        console.log('error', error);
      });
    },
  },
  created() {
    this.getQuestions();
  },
}
</script>